import { Category, DbSession, Exercise, Session } from "../types";
import { isAiExercise, isTraditionalExercise } from "./exercises";

export function convertSessionToDbSession(session: Session): DbSession {
    const exercises = session.exercises.filter(isTraditionalExercise);
    const aiExercises = session.exercises.filter(isAiExercise);

    const durationTotal = session.exercises.reduce((acc, exercise) => acc + exercise.duration, 0);
    const durationEndurance = getTimeForCategory(exercises, Category.Endurance);
    const durationStrength = getTimeForCategory(exercises, Category.Strength);
    const durationCoordination = getTimeForCategory(exercises, Category.Coordination);
    const durationRelaxation = getTimeForCategory(exercises, Category.Relaxation);
    const durationMobility = getTimeForCategory(exercises, Category.Mobility);
    const durationAi = aiExercises.reduce((acc, exercise) => acc + exercise.duration, 0);

    return {
        id: 0,
        durationTotal,
        durationEndurance,
        durationStrength,
        durationCoordination,
        durationRelaxation,
        durationMobility,
        durationAi,
        exercises,
        aiExercises: aiExercises.map((exercise) => exercise.id),
        createdAt: new Date().toISOString(),
    };
}

function getTimeForCategory(exercises: Array<Exercise & { duration: number }>, category: Category) {
    return exercises.reduce((acc, exercise) => (exercise.category === category ? acc + exercise.duration : acc), 0);
}
